import { settingsTexts } from 'consts/text';
import { LabelMapper, MethodOfCalcTheFee } from 'types';

export const methodOfCalcTheFeeLabels: LabelMapper<MethodOfCalcTheFee> = {
    HOURLY: settingsTexts.settlements.stays.formLabels.hourlyMethodOfCalcTheFee,
    MONTHLY: settingsTexts.settlements.stays.formLabels.monthlyMethodOfCalcTheFee,
};
